<template>
  <div>
    <v-data-table 
      :headers="headers" 
      :items="rows" 
      class="elevation-1 tableCust1 ma-0"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
            <v-btn-toggle dense>
              <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="newItem" :disabled="seriesSelected ? false : true">
                <v-icon left dark>fa-plus</v-icon>
                {{ $t('common.form.add') }}
              </v-btn> &nbsp;&nbsp;
              <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="importItem" :disabled="seriesSelected ? false : true">
                <v-icon left dark>far fa-file-import</v-icon>
                {{ $t('common.form.import') }}
              </v-btn>
            </v-btn-toggle>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="formB" class="pt-4 inputSeries"  v-on:submit.prevent="pressEnter">
                  <v-row>
                    <v-col cols="12">
                    <v-text-field v-if="editorType == 'new' || editorType == 'edit'"
                      v-model="inputName"
                      ref="inputName"
                      :label="$tc('common.form.name')"
                      required
                      outlined dense
                      :error-messages="brandExistsError"
                      :rules="[
                        (v) => $inputRules({value: v, minSize: 0, maxSize: 50}, 'fieldLength') || $t('page.series.name-required')
                      ]"
                      @keyup.enter="pressEnter"
                    ></v-text-field>
                    <v-select v-if="editorType == 'import'"
                      v-model="seriesModel"
                      :items="seriesItems"
                      ref="selectInput"
                      :label="$t('page.series.import-series-from')"
                      outlined dense
                      required
                      :rules="[ v => !!v || $t('page.series.series-required')]"
                      @keyup.enter="importBrands"
                    ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="close">{{ $t('common.form.cancel') }}</v-btn>
                <v-btn v-if="editorType == 'new'" color="blue darken-1" small text @click="create">{{ $t('common.form.create') }}</v-btn>
                <v-btn v-if="editorType == 'edit'" color="blue darken-1" small text @click="save">{{ $t('common.form.update') }}</v-btn>
                <v-btn v-if="editorType == 'import'" color="blue darken-1" @click="importBrands" small text>{{ $t('common.form.import') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
      <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
      @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
      <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
  </div>
</template>


<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  mixins: [apiCalls],
  properties: [],
  components: {
    SGSNotificationConfirm, SGSNotificationAlert
  },
  data() {
    return {
      dialogNotification: false,
      inputName: '',
      seriesModel: null,
      seriesItems: [],
      dialog: false,
      importDialog: true,
      rows: [],
      item: {
        id: "",
        name: 0
      },
      editorType: "new",
      dialogAlert: false,
      alertMessage: '',
      reopenEdition: false,
      indexDialog: 'dialog',
      brandExistsError: null
    };
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    formTitle() {
      let title = ''

      if (this.editorType == "new") title = this.$t('page.series.add-brand')
      if (this.editorType == "edit") title = this.$t('page.series.edit-brand')
      if (this.editorType == "import") title = this.$t('page.series.import-brands')
      
      return title
    },
    headers() {
      return [
        {
          text: this.$t("common.table.name"),
          value: "name"
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    seriesSelected() {
      this.getRecords();
      this.getSeries();
    }
  },
  methods: {
    init()
    {
      this.getRecords();
      this.getSeries();
    },
    pressEnter(){
      if(this.editorType == "edit"){
        this.save()
      }else{
        this.create()
      }
    },  
    async getRecords() {
      if(this.seriesSelected) {
        const response = await this.api(
          'get',
          `/api/v1/promoter/series/brand/${this.seriesSelected.id}`
        );

        this.rows = [];
        response.message.data.forEach(element => {
          const row = { id: element.id, name: element.brandName, actions: "actions", value: element.id,  text: element.brandName };
          this.rows.push(row);
        });
      }
    },
    async getSeries() {
      if(this.seriesSelected) {
        const response = await this.getApi(
          "/api/v1/promoter/series"
        );

        if (response != undefined) {        
          for(var i = 0; i < response.length; i++){
            if(response[i].id == this.seriesSelected.id){
              continue;
            }
            this.seriesItems.push({
              text: response[i].seriesName,
              value: response[i].id
            });          
          }
          this.allSeries = response;
        }
      }
    },
    newItem() {
      this.inputName = '';
      if(this.$refs.formB) {
        this.$refs.formB.resetValidation();
      }
      this.editorType = "new"
    },
    importItem(){
      if(this.$refs.formB) {
        this.seriesModel == null;
        this.$refs.formB.reset();
      }
      this.editorType = "import";
      this.dialog =  true
    },
    editItem(item){
      this.editorType = "edit"
      if(this.$refs.formB) {
        this.$refs.formB.resetValidation();
      }
      this.dialog = true
      this.inputName = item.name
      this.item.id = item.id
    },
    confirmDelete(item){
      this.dialogNotification = true
      this.item = item
    },

    async deleteItem() 
    {
      let data = {
        id: this.item.id
      }

      const response = await this.api('DELETE', `/api/v1/promoter/series/brand/${this.item.id}`, data);      
      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
      } else {
        if(!response) {
          this.dialogAlert =  true;
          this.alertMessage = this.$t('page.series.error_general');
        } else if (response && (response.error || response.message)) {
          if(Array.isArray(response.error)) {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0], { field: this.$t('page.series.brand') });
          } else if(typeof response.error == 'string') {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error, { field: this.$t('page.series.brand') });
          } else if(response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('page.series.'+response.message[0]);
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('page.series.'+response.message, { field: this.$t('page.series.brand') });
            }
            this.dialogAlert =  true;
          } else {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.error_general');
          }
        }
      }
    },

    close() {
      this.dialog = false;
      this.dialogNotification = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async create(){
      if(!this.$refs.formB.validate()) {
        if(this.inputName == ''){
          this.$refs.inputName.focus();
          return
        }
        return;
      }

      let data = {
        seriesId: this.seriesSelected.id,
        brandName: this.inputName
      }

      const response = await this.api("POST", "/api/v1/promoter/series/brand", data);
      
      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
        this.reopenEdition = false;
      } else {
        this.brandExistsError = this.$t('page.series.'+response.message, {'suggestion': response.suggestion});
      }
    },
    closeAlert(){
      this.dialogAlert=false;
      if(this.reopenEdition){
        this.dialog = true;
      }
    },
    async importBrands(){

      if(!this.$refs.formB.validate()) {
        if(this.seriesModel == null || this.seriesModel == ''){
          this.$refs.selectInput.focus();
          return false;
        }
        return;
      }
      

      this.dialog = false

      let data = {
        seriesId: this.seriesSelected.id,
        importId: this.seriesModel
      }

      const response = await this.api("POST", "/api/v1/promoter/series/brand/importSeriesBrands", data);

      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
        this.reopenEdition = false;
      } else {
        if (response && (response.error || response.message)) {
          if(Array.isArray(response.error)) {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0]);
            this.reopenEdition = true;
          } else if(typeof response.error == 'string') {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error);
            this.reopenEdition = true;
          } else if(response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('page.series.'+response.message[0]);
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('page.series.'+response.message, { field: this.$t('page.series.brand') });
            }
            this.dialog = false;
            this.dialogAlert =  true;
            this.reopenEdition = true;
          } else {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.error_general');
            this.reopenEdition = true;
            }
        }
      }
    },
    async save() {   
      this.brandExistsError = null;
      if(!this.$refs.formB.validate()) {
        if(this.inputName == ''){
          this.$refs.inputName.focus();
          return
        }
        return;
      }

      let data = {
        id: this.item.id,
        brandName: this.inputName,
        seriesId: this.seriesSelected.id
      }

      const response = await this.api("PUT", "/api/v1/promoter/series/brand", data);
      
      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
        this.reopenEdition = false;
        this.brandExistsError = null;
      } else {
        this.brandExistsError = this.$t('page.series.'+response.message, {'suggestion': response.suggestion});
      }

    }
  }
};
</script>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-darken2) !important;
    color: white !important;
}
</style>